import { m } from 'framer-motion';
// @mui
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// assets
import { ForbiddenIllustration } from '../assets/illustrations';
import { MotionContainer, varBounce } from '../components/animate';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function NotAllowedPage() {

    const navigate = useNavigate();
    
    return (
        <MotionContainer>
            <m.div variants={varBounce().in}>
                <Typography variant="h3" sx={{ mb: 2 }}>
                    Sem Permissão
                </Typography>
            </m.div>

            <m.div variants={varBounce().in}>
                <Typography sx={{ color: 'text.secondary' }}>
                    A página que você está tentando acessar tem acesso restrito.
                    <br />
                    Consulte o administrador do sistema
                </Typography>
            </m.div>

            <m.div variants={varBounce().in}>
                <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
            </m.div>

            <Button onClick={() => navigate(-2)} size="large" variant="contained">
                Voltar á Página Anterior
            </Button>
        </MotionContainer>
    );
}
